import { memo, useEffect } from "react";
import { Flex, Pagination, Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { enmConfirmationStatus } from "../../models/enums/ConfirmationStatus";
import { mdlReservationEntryItem } from "../../models/domain/ReservationEntryItem";
import _ from "lodash";
import { mdlReservationEntryViewItem } from "../../models/domain/ReservationEntryViewItem";

export type EntryListTableProps = {
    entries?: mdlReservationEntryViewItem[];

}

export const EntryListTable = memo(function EntryListTable(props: EntryListTableProps) {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    const columns: TableProps<mdlReservationEntryViewItem>['columns'] = [
        {
            sorter: (a, b) => a.operator! > b.operator! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.operator"),
            dataIndex: 'operator',
            key: 'operator'
        },
        {
            sorter: (a, b) => a.confirmationStatus! > b.confirmationStatus! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.confirmStatus"),
            key: 'confirmationStatus',
            render: (e: mdlReservationEntryViewItem) => {
                switch (e.confirmationStatus) {
                    case enmConfirmationStatus.Yes:
                        return (t("entryList.confirmStatusYes"));
                    case enmConfirmationStatus.No:
                        return (t("entryList.confirmStatusNo"));
                    default:
                        return (t("entryList.confirmStatusWait"));
                }
            }
        },
        {
            title: t("entryList.hotel"),
            dataIndex: 'hotelName',
            key: 'hotelName',
        },
        {
            sorter: (a, b) => a.agencyName! > b.agencyName! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.agency"),
            dataIndex: 'agencyName',
            key: 'agencyName',
        },
        {
            sorter: (a, b) => a.voucher! > b.voucher! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.voucher"),
            dataIndex: 'voucher',
            key: 'voucher',
        },
        {
            title: t("entryList.title"),
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: t("entryList.customerName"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t("entryList.nationality"),
            dataIndex: 'nationality',
            key: 'nationality',
        },
        {
            sorter: (a, b) => a.arrival! > b.arrival! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.arrival"),
            dataIndex: 'arrival',
            key: 'arrival',
        },
        {
            sorter: (a, b) => a.arrivalTime! > b.arrivalTime! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.arrivalTime"),
            key: 'arrivalTime',
            render: (e: mdlReservationEntryViewItem) => {
                return e.arrivalTime ? (dayjs(e?.arrivalTime).format("HH:mm")) : "-"
            }
        },
        {
            sorter: (a, b) => a.departure > b.departure ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.departure"),
            dataIndex: 'departure',
            key: 'departure',
        },
        {
            sorter: (a, b) => a.departureTime! > b.departureTime! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.departureTime"),
            key: 'departureTime',
            render: (e: mdlReservationEntryViewItem) => {
                return e.departureTime ? (dayjs(e?.departureTime).format("HH:mm")) : "-"
            }
        },
        {
            sorter: (a, b) => a.checkInDate! > b.checkInDate! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.checkInDate"),
            key: 'checkInDate',
            render: (e: mdlReservationEntryItem) => {
                return (dayjs(e.checkInDate).format("DD.MM.YYYY"))
            }
        },
        {
            sorter: (a, b) => a.checkOutDate! > b.checkOutDate! ? -1 : 1,
            sortDirections: ['descend'],
            showSorterTooltip: { target: 'full-header' },
            title: t("entryList.checkOutDate"),
            key: 'checkOutDate',
            render: (e: mdlReservationEntryItem) => {
                return (dayjs(e.checkOutDate).format("DD.MM.YYYY"))
            }
        },
    ];

    return (
        <>
            {
                props.entries
                &&
                <Flex gap="middle" vertical>
                    <Table<mdlReservationEntryViewItem>
                        size="small"
                        columns={columns}
                        dataSource={props.entries.map((entryItem: mdlReservationEntryViewItem, index: number) => ({ ...entryItem, key: index }))}
                        pagination={false}
                    />
                </Flex>
            }
        </>
    )
})